import {
  checkDeleted,
  checkListDeleted,
  displayNameDescriptor,
  nameDescriptor,
} from 'pages/AutomationEngine/helpers';
import {
  AddErrorMessage,
  MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';
import { CodeStepDetails } from './types';

const forFlow = (
  apiObject: CodeStepDetails,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary,
  stepType: 'code_step'
) => {
  checkListDeleted(
    messageDictionary,
    addErrorMessage,
    apiObject.secrets,
    nameDescriptor
  );

  apiObject.inputs?.forEach((input) => {
    if (input.inputType === 'field' || input.inputType === 'related_field') {
      checkDeleted(
        messageDictionary,
        addErrorMessage,
        input.field,
        displayNameDescriptor
      );
    }
    if (input.inputType === 'related_field') {
      checkDeleted(
        messageDictionary,
        addErrorMessage,
        input.relatedField,
        displayNameDescriptor
      );
    }
  });

  apiObject.outputs?.forEach((output) => {
    if (
      output.outputType === 'field' ||
      output.outputType === 'related_field'
    ) {
      checkDeleted(
        messageDictionary,
        addErrorMessage,
        output.field,
        displayNameDescriptor
      );
    }
    if (output.outputType === 'related_field') {
      checkDeleted(
        messageDictionary,
        addErrorMessage,
        output.relatedField,
        displayNameDescriptor
      );
    }
  });

  return { ...apiObject, type: stepType };
};

const forApi = (
  step: any,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary
) => {
  const api = step;

  return api;
};

export const codeStepDTO = { forApi, forFlow };
